<template>
  <v-container
    v-if='loaded'
    fill-height
    fluid
    grid-list-xl>
    <v-layout wrap>

    
      <v-flex
        v-if="$can('read','protocol')"
        sm6
        xs12
        md6
        lg3>

        <material-stats-card
          color="primary"
          icon="mdi-clipboard-text"
          title="Protocols"
          sub-icon="mdi-view-list"
          :value="String(dashboardData.protocol)"
          :sub-text="`Protocols list`"
          to="/protocol"
        />
      </v-flex>

      <v-flex
        v-if="$can('read','site')"
        sm6
        xs12
        md6
        lg3>
        <material-stats-card
          color="orange"
          icon="mdi-hospital-building"
          title="Sites"
          :value="String(dashboardData.site)"
          sub-icon="mdi-view-list"
          sub-text-color="float-right"
          :sub-text="`Sites list`"
          to="/site"
        />
      </v-flex>

      <v-flex
        v-if="$can('read','account')"
        sm6
        xs12
        md6
        lg3>
        <material-stats-card
          color="info"
          icon="mdi-account"
          title="Accounts"
          :value="String(dashboardData.account)"
          sub-icon="mdi-view-list"
          :sub-text="`Accounts list`"
          to="/account"
        />
      </v-flex>

      <v-flex
        v-if="$can('read','meddra')"
        sm6
        xs12
        md6
        lg3>
        <material-stats-card
          color="green"
          icon="mdi-book-alphabet"
          title="MedDRA Version"
          :value="String(dashboardData.meddra_version)"
          sub-icon="mdi-view-list"
          :sub-text="`MedDRA list`"
          to="/meddra"
        />
      </v-flex>


      <v-flex md12  v-if="$can('read','log')">
        <core-table hide-upsert :config="config_log" title="Audit Trail"/>
      </v-flex>

    
    </v-layout>
  </v-container>
</template>

<script>
import { getDashboardData } from '@/api/log'
import config_log from '@/views/config_log'

export default {
  data () {
    return {
      config_log,
      dashboardData: {
        protocol:'',
        site:'',
        accouhnt:'',
        meddra_version:''
      },
      loaded: false
    }
  },
  computed: {
  },
  async mounted () {
    this.getDashboardData()
    config_log.setApp(this)
  },
  methods: {
    getDashboardData () {
      getDashboardData().then(data => {
        this.dashboardData = data
        this.loaded = true
      })
    },
  }
}
</script>

<style lang="scss">
.dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
      padding: 0px 5px 0px 5px;
  }
}
</style>
